import { User } from 'api/models';
import { TimesheetCalendarSourceType } from 'api/timesheets';

interface MeetingMeta {
  participants: Pick<
    User,
    'emailId' | 'firstName' | 'lastName' | 'photoUrl' | 'company'
  >[];
}
export interface Meeting {
  meetingId: number;
  meetingName: string;
  startTime: number;
  endTime: number;
  externalMeetingId: string;
  updatedAt: number;
  createdAt: number;
  deleted: boolean;
  externalMeetingDeleted: boolean;
  summaryAvailable: boolean;
  meta: MeetingMeta;
  companyId: number;
}

export enum MeetingProvider {
  Zoom = 'ZOOM',
  GoogleMeet = 'MEET',
  MicrosoftTeams = 'TEAMS',
  Gong = 'GONG',
}

export interface RecordingMeta {
  provider: MeetingProvider;
  shouldSendBot: boolean;
  cloudRecordingEnabled: boolean;
  integrationId: number;
}

export type RecordingMetaExtended = RecordingMeta & { isConnected: boolean };

export interface MeetingSettings {
  aiFillsEnabled: boolean;
  gongEnabled: boolean;
  botName: string;
  calendar: TimesheetCalendarSourceType;
  recordingMeta: RecordingMeta[];
  recordingMetaByProvider?: Record<MeetingProvider, RecordingMetaExtended>; // will be transformed at the react query layer and this property will be filled in.
}

export interface MeetingFeatureFlag {
  enabled: boolean;
}
